<template>
  <b-nav-item-dropdown v-editable="blok" :text="blok.label">
    <b-dropdown-item :key="index" v-for="(el,index) in blok.items" class="dropdown-item" :href="el.link.cached_url | formatSbInternalLink">{{ el.label }}</b-dropdown-item>
  </b-nav-item-dropdown>
</template>
<script>
export default {
    name: 'navigation-group',
    props: {
        blok: Object
    }
}
</script>